var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('i',{class:_vm.setClassStatus(_vm.data)})])
}
var staticRenderFns = []

export { render, staticRenderFns }